module.exports = __webpack_public_path__ + "img/4C.64502802.png";